import React from 'react';
import {Modal} from 'react-bootstrap';
import logo from "../../../assets/images/bim-logo.png";
import logodark from "../../../assets/images/bim-logo-dark.png";
import ReceiptTable from "./ReceiptTable";
import ReceiptHeader from "./ReceiptHeader";
import ReceiptSummary from "./ReceiptSummary";
import { useSelector } from 'react-redux';
import {LAYOUT_MODE_TYPES} from "../../../Common/constants/layout";


const ReceiptModal = ({selectedTransaction, setSelectedTransaction}: any) => {
    const layout = useSelector((state: any) => state.Layout);
    if (!selectedTransaction) return null;

    return (
        <Modal
            show={!!selectedTransaction}
            onHide={() => setSelectedTransaction(null)}
            size="lg"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <div className="logo logo-dark">
                        {
                            layout.layoutModeType === LAYOUT_MODE_TYPES.LIGHTMODE ?
                                <span className="logo-sm"><img src={logo} alt="" height="22"/></span> :
                                <span className="logo-lg"><img src={logodark} alt="" height="21"/></span>
                        }
                    </div>
                </Modal.Title>

            </Modal.Header>
            <Modal.Body>
                <ReceiptHeader receipt={selectedTransaction} />
                <ReceiptTable items={selectedTransaction.items}/>
                <ReceiptSummary receipt={selectedTransaction} />
            </Modal.Body>
        </Modal>
    );
};

export default ReceiptModal;
